import { GraphQLInt, GraphQLList, GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql';

import {
	MyAvatar,
	TeamInSlack,
	TeamLinkIcon,
	User,
	UserManageConfig,
	UserManageLinkedAccounts,
	UserManagePrivacySettings,
	UserManagePrivacySettingsAllowed,
	UserOrganization,
} from '../types';
import Containers from '../types/Containers';

const QueryRoot = new GraphQLObjectType({
	fields: {
		UserOrganization: {
			type: UserOrganization,
		},
		User: {
			type: User,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		MyAvatar: {
			type: MyAvatar,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		UserManageConfig: {
			type: UserManageConfig,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		UserManagePrivacySettings: {
			type: UserManagePrivacySettings,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		UserManagePrivacySettingsAllowed: {
			type: UserManagePrivacySettingsAllowed,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		UserManageLinkedAccounts: {
			type: UserManageLinkedAccounts,
			args: {
				userId: { type: new GraphQLNonNull(GraphQLString) },
			},
		},
		TeamInSlack: {
			type: TeamInSlack,
			args: {
				teamId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				teamName: {
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
		Containers: {
			type: Containers,
			args: {
				principalId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				siteId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				userId: {
					type: new GraphQLNonNull(GraphQLString),
				},
				maxNumberOfResults: {
					type: new GraphQLNonNull(GraphQLInt),
				},
				sessionId: {
					type: new GraphQLNonNull(GraphQLString),
				},
			},
		},
		TeamLinkIcons: {
			type: new GraphQLList(TeamLinkIcon),
			args: {
				teamLinkUrls: {
					type: new GraphQLList(GraphQLString),
				},
			},
		},
	},
	name: 'Query',
});

export default QueryRoot;
